import { render, staticRenderFns } from "./AppSelectButtonLegacy.vue?vue&type=template&id=871b1066&scoped=true"
import script from "./AppSelectButtonLegacy.vue?vue&type=script&lang=js"
export * from "./AppSelectButtonLegacy.vue?vue&type=script&lang=js"
import style0 from "./AppSelectButtonLegacy.vue?vue&type=style&index=0&id=871b1066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871b1066",
  null
  
)

export default component.exports